import Proptypes from "prop-types";
import IconButton from "@shared/v2/IconButton";
import { TrashCanSolidV6 } from "@shared/v2/Icomoon";
import * as transactionCss from "../PersonDetail/components/transactions.module.css";

const ListingPreviewCard = ({ containerClassName, listingData, clearListing, BtnIcon }) => {
  const {
    beds,
    bedrooms,
    city,
    baths,
    bathsTotalDecimal,
    mlsNumber,
    photos,
    postalCode,
    price,
    sqFt,
    squareFeet,
    state,
    streetAddress,
  } = listingData ?? {};
  return (
    <div className={`${transactionCss.previewCard} ${containerClassName}`}>
      <div className={`${transactionCss.header} tw-flex tw-justify-between tw-items-center`}>
        <span>Listing Details</span>
        <IconButton schema="tertiary" onClick={() => clearListing(null)}>
          <BtnIcon />
        </IconButton>
      </div>
      <div className={transactionCss.content}>
        <div className={transactionCss.listingImg}>
          <img src={photos.length ? photos[0].url : ""} alt="listing" />
        </div>
        <div className={transactionCss.details}>
          <p>{streetAddress?.toUpperCase() || "No address available"}</p>
          <p>{`${city || "-"}, ${state || "-"} ${postalCode || "-"}`}</p>
          {Number.isInteger(parseInt(price, 10)) && <p>${price.toLocaleString()}</p>}
          <p>{`${beds || bedrooms || "-"} beds | ${baths || bathsTotalDecimal || "-"} baths | ${sqFt?.toLocaleString() || squareFeet?.toLocaleString() || "-"} sqft`}</p>
        </div>
      </div>
      <div>{mlsNumber && <span className={transactionCss.mlsCredit}>{`MLS #${mlsNumber}`}</span>}</div>
    </div>
  );
};

export default ListingPreviewCard;

ListingPreviewCard.propTypes = {
  listingData: Proptypes.shape({ name: Proptypes.bool }),
  clearListing: Proptypes.func,
  containerClassName: Proptypes.string,
  BtnIcon: Proptypes.func,
};

ListingPreviewCard.defaultProps = {
  listingData: null,
  clearListing: null,
  containerClassName: "",
  BtnIcon: TrashCanSolidV6,
};
